import { render } from "./Organizations.vue?vue&type=template&id=9bffa0a4&scoped=true"
import script from "./Organizations.vue?vue&type=script&lang=js"
export * from "./Organizations.vue?vue&type=script&lang=js"

import "./Organizations.vue?vue&type=style&index=0&id=9bffa0a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bffa0a4"]])

export default __exports__